export default __webpack_public_path__ + "static/media/HV B2B Banner laminate.431c06c9.jpg";